export default __webpack_public_path__ + "static/media/SMARTER (Transparent).30cf92ba.png";